import { writeSettingsFields } from './settings-fields';

/** `PATCH /client/settings/fields`: `settings.trip_sequencing`. */
export const editTripSequencing = async (trip_sequencing: object): Promise<any> =>
  writeSettingsFields({ trip_sequencing });
